<template>
	<CombinedPage label="settings" :routes="routes" mode="tabs" includeImportButtons />
</template>

<script>
import CombinedPage from '@/components/common/CombinedPage';
import { useSettingsRoutes } from '@/components/top_level/navigationConsts/settingsRoutes';

export default {
	components: {
		CombinedPage,
	},
	setup() {
		return {
			routes: useSettingsRoutes(),
		};
	},
}
</script>
